import Form, { IChangeEvent } from "@rjsf/core";
import { RJSFSchema } from "@rjsf/utils";
import Spinner from "@salesforce/design-system-react/components/spinner";
import React, { useState } from "react";
import classNames from "classnames";
import {
  FactoryDigitalmallBackofficeV1Mall,
  MallServiceCreateMallApiArg,
  useMallServiceCreateMallMutation,
} from "../../app/genericApiGenerated";
import { SLDSFormNew } from "../../@core/components/JSONSchemaForm/JSONSchemaForm";
import CreateMallFormSchema from "./CreateMallFormSchema";
import CreateMallFormUISchema from "./CreateMallFormUISchema";
import buildMall from "./buildMall";

interface CreateMallFormProps {
  postProcessData?: (data: any) => any;
  onFormSubmitted?: (v: FactoryDigitalmallBackofficeV1Mall) => void;
  onFormChanged?: (data: any) => void;

  notSpaced?: boolean;
}

const CreateMallForm = React.forwardRef< 
Form<any, RJSFSchema, any>,
CreateMallFormProps
>((props, ref) => {
  const [formData, setFormData] = useState({});
  const [
    mallServiceCreateMall, // This is the mutation trigger
    { isLoading }, // This is the destructured mutation result
  ] = useMallServiceCreateMallMutation();

  const onSubmit = async (
    { formData: data }: IChangeEvent<any, any>,
    event: React.FormEvent<any>
  ) => {
    data =
      props.postProcessData !== undefined ? props.postProcessData(data) : data;
    const mallCreationReq: MallServiceCreateMallApiArg = {
      factoryDigitalmallBackofficeV1Mall: buildMall(data),
    };

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const payload = await mallServiceCreateMall(mallCreationReq).unwrap();
      props.onFormSubmitted?.(payload);
      setFormData({});
    } catch (error) {
      // console.error('rejected', error);
    }
    //
  };

  return (
    <div className="slds-is-relative">
      <section
        className={classNames({ "slds-p-around_large": !props.notSpaced })}
        style={{ minHeight: "5rem" }}
      >
        <SLDSFormNew
          id="create-mall-form"
          schema={CreateMallFormSchema as RJSFSchema}
          uiSchema={CreateMallFormUISchema}
          onSubmit={onSubmit}
          formData={formData}
          onChange={({ formData: data }) => {
            props.onFormChanged?.(data);
            setFormData(data);
          }}
          isLoading={isLoading}
          ref={ref}
        />
      </section>
    </div>
  );
});

export default CreateMallForm;
